import { ContentBodyTypeEnum } from "@/types/contents"

export const contentBodyAttributes = {
  [ContentBodyTypeEnum.article]: {
    body: "",
    reading_time: null as number | null,
  },
  [ContentBodyTypeEnum.audio]: {
    caption: "",
    duration_seconds: null as number | null,
    transcript: "",
    source: "",
  },
  [ContentBodyTypeEnum.photo]: {
    alt_text: "",
    caption: "",
    image: null as File | null,
  },
  [ContentBodyTypeEnum.video]: {
    aspect: "",
    caption: "",
    duration_seconds: null as number | null,
    source: "",
  },
}
